import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { useGetLocations } from "./useGetLocations";

export const useAvailableLocations = () => {
    const { selectedOrganization: selectedOrg } = useSelectedOrganization();
    return useGetLocations(selectedOrg?.id);
};